export interface AsyncStorage {
    getItem<T>(key: StorageKey, defaultValue: T): Promise<T>;
    setItem(key: StorageKey, value: string | object): Promise<void>;
    clearCache(): void;
}

export interface StorageKey {
    endpoint: string;
    cacheId: string;
}

export const channelKey = (channel: string, identifier: string): StorageKey => ({
    endpoint: `settings/channel/${channel}/${identifier}`,
    cacheId: `channel.${channel}.${identifier}`,
});

export const userKey = (identifier: string): StorageKey => ({
    endpoint: `settings/user/${identifier}`,
    cacheId: `user.${identifier}`,
});



// WEBPACK FOOTER //
// ./src/storage/storage.ts